import ISpin from "ispin";
import IMask from "imask";
import { debounce } from "../utils/debounce";

function numberInputInit() {
  const widgets = document.querySelectorAll(".js-number-input.not-ready");

  [...widgets].forEach(widget => {
    const prefix = widget.getAttribute("data-prefix") || "";
    const suffix = widget.getAttribute("data-suffix") || "";
    const disabled = widget.hasAttribute("disabled");
    const step = parseInt(widget.getAttribute("step")) || 1;
    const min = widget.hasAttribute("min")
      ? parseInt(widget.getAttribute("min"))
      : -Infinity;
    const max = widget.hasAttribute("max")
      ? parseInt(widget.getAttribute("max"))
      : Infinity;

    widget.classList.remove("not-ready");

    const spinner = new ISpin(widget, {
      wrapperClass: "number-input",
      buttonsClass: "number-input__button",
      min,
      max,
      step,
      disabled,
      onChange() {
        mask.updateValue();
        $(widget).trigger("input");
      },
      parse: parseInt
    });

		const mask = new IMask(widget, {
			mask: prefix + 'numBlock{ \\' + suffix + '}',
			placeholderChar: '',
			blocks: {
				numBlock: {
					// nested masks are available!
					mask: Number,
					min,
					max,
					scale: 0, // digits after point, 0 for integers
					signed: false // disallow negative
				}
			},
			lazy: false
		});
  });
}

window.addEventListener("ajax-addtocart", debounce(numberInputInit));
numberInputInit();
